import React from "react";
import { Plus } from "lucide-react";

import Button from "../../../../components/buttons/Button";
import { EllipsisMenu } from "../../../../components/menu/ellipsis/EllipsisMenu";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ViewHeader from "../../../../components/layout/view/ViewHeader";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Heading from "../../../../components/typography/Heading";
import Text from "../../../../components/typography/Text";

import { formatDate } from "../utils/talentUtils";

import "./TalentAchievementsView.css";

export default function TalentAchievementsView({
  achievements = [],
  onAdd,
  onEdit,
  onRemove,
  busy = false,
  readOnly = false,
}) {
  const achievementList = Array.isArray(achievements) ? achievements : [];

  return (
    <ViewContainer>
      <ViewHeader
        title="Achievements"
        description="My sporting achievements, awards and milestones."
        actions={
          !readOnly && (
            <Button
              value="Add Achievement"
              icon={<Plus size={16} />}
              variant="primary-outlined"
              disabled={busy}
              onClick={onAdd}
            />
          )
        }
      />

      <ContentPanel>
        {!achievementList.length ? (
          <Text as="p" tone="secondary" size="sm">
            No sporting achievements added yet.
          </Text>
        ) : (
          <div className="user-talent__entries">
            {achievementList.map((item) => {
              const details = [
                item.organisation,
                item.sport,
                item.achievementType,
              ]
                .filter(Boolean)
                .join(" · ");

              return (
                <ContentItem
                  key={item.achievementId}
                  actions={
                    !readOnly && (
                      <EllipsisMenu
                        ariaLabel={`${item.title} options`}
                        position="right"
                        disabled={busy}
                        options={[
                          {
                            id: "edit",
                            label: "Edit Achievement",
                            action: () => onEdit?.(item),
                          },
                          {
                            id: "delete",
                            label: "Delete Achievement",
                            className: "is-danger",
                            action: () => onRemove?.(item),
                          },
                        ]}
                      />
                    )
                  }
                >
                  <Heading as="h3" size="sm">
                    {item.title}
                  </Heading>

                  {details && (
                    <Text as="p" tone="secondary" size="sm">
                      {details}
                    </Text>
                  )}

                  {item.achievedOn && (
                    <Text as="p" tone="secondary" size="sm">
                      {formatDate(item.achievedOn)}
                    </Text>
                  )}

                  {item.description && (
                    <Text as="p" className="user-talent__body">
                      {item.description}
                    </Text>
                  )}
                </ContentItem>
              );
            })}
          </div>
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
